// ── KOVA CART ENGINE ─────────────────────────────────────
var __kovaGiftProductId = 9703287751013;
var __kovaGiftVariants = {1:50234334445925,2:50234334478693,3:50234334511461,4:50234334544229,5:50234334576997,6:50234334609765,7:50234334642533,8:50234339656037,9:50234339688805,10:50234339721573,11:50234339754341,12:50234339787109};

function kovaTierCount(cart) {
  return cart.items.reduce(function(n, item) {
    return n + (item.product_id === __kovaGiftProductId ? 0 : item.quantity);
  }, 0);
}
function kovaHasGift(cart) {
  return cart.items.some(function(item) { return item.product_id === __kovaGiftProductId; });
}
// El regalo se desbloquea a las 5 prendas. Si el carrito baja de ahi, se retira.
var __kovaGiftRemoveTries = 0;

function kovaGiftNotice(msg) {
  ['drawer', 'page'].forEach(function (ctx) {
    var host = document.getElementById('kova-tier-' + ctx);
    if (!host) return;
    var el = document.getElementById('kova-gift-note-' + ctx);
    if (!el) {
      el = document.createElement('p');
      el.className = 'kova-gift-note';
      el.id = 'kova-gift-note-' + ctx;
      host.appendChild(el);
    }
    el.textContent = msg;
    el.hidden = false;
    clearTimeout(el._kovaTimer);
    el._kovaTimer = setTimeout(function () { el.hidden = true; }, 7000);
  });
}

// Devuelve true si se dispara un retiro (y por lo tanto habra un re-render).
function kovaGiftEnforce(cart, tierN) {
  if (tierN >= 5) { __kovaGiftRemoveTries = 0; return false; }
  var gift = null;
  for (var i = 0; i < cart.items.length; i++) {
    if (cart.items[i].product_id === __kovaGiftProductId) { gift = cart.items[i]; break; }
  }
  if (!gift) return false;
  // Guardas: nunca dos retiros en paralelo, y maximo 2 intentos por si el
  // servidor no lo quita (evita un bucle de render -> fetch -> render).
  if (window.__kovaGiftRemoving || __kovaGiftRemoveTries >= 2) return false;
  window.__kovaGiftRemoving = true;
  __kovaGiftRemoveTries++;
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: gift.key, quantity: 0 })
  })
  .then(function (r) { return r.json(); })
  .then(function (c) {
    window.__kovaGiftRemoving = false;
    kovaGiftNotice('Quitamos el regalo sorpresa: se desbloquea con 5 prendas.');
    updateCartCounts(c.item_count);
    // La pagina /cart se pinta con Liquid, no con renderCartItems: hay que recargar.
    if (/^\/cart(\/|$)/.test(window.location.pathname)) { window.location.reload(); return; }
    renderCartItems(c);
  })
  .catch(function () { window.__kovaGiftRemoving = false; });
  return true;
}

// Mismo texto que snippets/cart-tier.liquid. Si cambia uno, cambia el otro.
function kovaTierCopy(n, hasGift) {
  if (n >= 5) {
    return hasGift
      ? { goal: 'Env\u00edo gratis y regalo', sub: 'Los dos van incluidos en tu pedido.' }
      : { goal: 'Regalo desbloqueado', sub: 'Elige la talla aqu\u00ed abajo.' };
  }
  var falta = n < 3 ? (3 - n) : (5 - n);
  return {
    goal: falta === 1 ? 'Te falta 1 prenda' : 'Te faltan ' + falta + ' prendas',
    sub: n < 3 ? 'Para tu env\u00edo gratis.' : 'Para tu regalo sorpresa.'
  };
}

function kovaUpdateTier(n, hasGift) {
  var copy = kovaTierCopy(n, hasGift);
  var pct = Math.min(n * 20, 100);

  ['drawer', 'page'].forEach(function (ctx) {
    var bar = document.getElementById('kova-tier-' + ctx);
    if (!bar) return;
    bar.style.display = n > 0 ? '' : 'none';

    var goalEl = document.getElementById('kt-goal-' + ctx);
    if (goalEl && goalEl.textContent.trim() !== copy.goal) {
      goalEl.textContent = copy.goal;
      // Reinicia la animacion: sin esto el navegador ignora la segunda vez.
      goalEl.classList.remove('kt-pulse');
      void goalEl.offsetWidth;
      goalEl.classList.add('kt-pulse');
    }

    var subEl = document.getElementById('kt-sub-' + ctx);
    if (subEl) subEl.textContent = copy.sub;

    var fill = document.getElementById('kt-fill-' + ctx);
    if (fill) fill.style.width = pct + '%';

    var barEl = bar.querySelector('.kt-bar');
    if (barEl) barEl.setAttribute('aria-valuenow', n);

    var s3 = document.getElementById('kt-step3-' + ctx);
    if (s3) s3.classList.toggle('done', n >= 3);
    var s5 = document.getElementById('kt-step5-' + ctx);
    if (s5) s5.classList.toggle('done', n >= 5);

    var giftBtn = document.getElementById('kova-gift-btn-' + ctx);
    if (giftBtn) giftBtn.style.display = (n >= 5 && !hasGift) ? 'block' : 'none';
  });
}

// ── PRODUCT GALLERY CAROUSEL ─────────────────────────────
function goToSlide(index) {
  const carousel = document.getElementById('product-carousel');
  if (!carousel) return;
  const slideWidth = carousel.offsetWidth;
  carousel.scrollTo({ left: slideWidth * index, behavior: 'smooth' });
  updateGalleryActiveState(index);
}
// Al filtrar la galería por color quedan diapositivas ocultas (.gal-hidden),
// así que la posición se cuenta solo sobre las visibles.
function galleryVisible(selector) {
  return Array.from(document.querySelectorAll(selector)).filter(el => !el.classList.contains('gal-hidden'));
}
function goToSlideFrom(el) {
  const i = galleryVisible('#product-thumbs .product-thumb').indexOf(el);
  if (i !== -1) goToSlide(i);
}
function updateGalleryActiveState(index) {
  galleryVisible('#product-thumbs .product-thumb').forEach((t, i) => t.classList.toggle('active', i === index));
  galleryVisible('#product-dots .pdot').forEach((d, i) => d.classList.toggle('active', i === index));
}

// Panel de compra rápida — última revisión 2026-08-20
// ── COMPRA RÁPIDA: PANEL INFERIOR ────────────────────────
// El "+" de cada tarjeta abre un panel que sube desde abajo. Los datos se
// piden a /products/<handle>.js al primer clic y se guardan en memoria, para
// no cargar el home con 58 catálogos de variantes.
//
// Ese endpoint expone `available` por variante pero NO `inventory_quantity`:
// por eso se marcan tallas agotadas pero no se dice cuántas quedan. La
// pre-venta llega desde la tarjeta (data-preorder), calculada en Liquid.
var QS = { cache: {}, prod: null, colorIdx: -1, sizeIdx: -1, color: null, size: null, opener: null, preorder: false };

function qsEscapeAttr(s) {
  return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;');
}
function qsMoney(cents) {
  return '$ ' + (cents / 100).toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}
function qsThumb(url, w) {
  if (!url) return '';
  if (url.indexOf('/cdn/') === -1) return url;
  return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
}
function qsOptionNames(p) {
  return (p.options || []).map(function (o) {
    return String(o && o.name !== undefined ? o.name : o).toLowerCase();
  });
}
function qsColorImage(color) {
  var p = QS.prod, hit = null;
  p.variants.some(function (v) {
    if (v.options[QS.colorIdx] === color && v.featured_image) { hit = v.featured_image.src; return true; }
    return false;
  });
  return hit || p.featured_image || null;
}
function qsVariant() {
  var p = QS.prod, hit = null;
  p.variants.some(function (v) {
    if (QS.colorIdx !== -1 && v.options[QS.colorIdx] !== QS.color) return false;
    if (QS.sizeIdx !== -1) {
      if (QS.size === null) return false;
      if (v.options[QS.sizeIdx] !== QS.size) return false;
    }
    hit = v; return true;
  });
  return hit;
}

function qaddOpen(btn) {
  var handle = btn.getAttribute('data-handle');
  if (!handle) return;
  QS.opener = btn;
  QS.preorder = btn.getAttribute('data-preorder') === '1';
  var preset = btn.getAttribute('data-color') || null;
  if (QS.cache[handle]) { qsRender(QS.cache[handle], preset); qsShow(); return; }
  btn.classList.add('is-loading');
  fetch('/products/' + handle + '.js')
    .then(function (r) { return r.json(); })
    .then(function (p) {
      QS.cache[handle] = p;
      btn.classList.remove('is-loading');
      qsRender(p, preset);
      qsShow();
    })
    .catch(function () {
      // Sin datos no hay panel: mandamos a la ficha, que siempre funciona.
      btn.classList.remove('is-loading');
      window.location.href = '/products/' + handle;
    });
}

function qsRender(p, presetColor) {
  QS.prod = p;
  var names = qsOptionNames(p);
  QS.colorIdx = names.indexOf('color');
  QS.sizeIdx = -1;
  for (var i = 0; i < names.length; i++) { if (i !== QS.colorIdx) { QS.sizeIdx = i; break; } }

  var colors = [], sizes = [];
  p.variants.forEach(function (v) {
    if (QS.colorIdx !== -1) {
      var c = v.options[QS.colorIdx];
      if (c && colors.indexOf(c) === -1) colors.push(c);
    }
    if (QS.sizeIdx !== -1) {
      var s = v.options[QS.sizeIdx];
      if (s && sizes.indexOf(s) === -1) sizes.push(s);
    }
  });
  QS.color = (presetColor && colors.indexOf(presetColor) !== -1) ? presetColor : (colors[0] || null);
  QS.size = null;

  var title = document.getElementById('qsTitle');
  title.textContent = p.title;

  var sw = document.getElementById('qsSwatches');
  sw.innerHTML = '';
  colors.forEach(function (c) {
    var src = qsColorImage(c);
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'qs-swatch';
    b.setAttribute('data-color', c);
    b.setAttribute('aria-label', c);
    b.title = c;
    b.innerHTML = src
      ? '<img src="' + qsEscapeAttr(qsThumb(src, 160)) + '" alt="' + qsEscapeAttr(p.title + ' color ' + c) + '" loading="lazy">'
      : '<span class="qs-swatch-txt">' + qsEscapeAttr(c.slice(0, 2)) + '</span>';
    // Al cambiar de color se conserva la talla: qsSync() la descarta sola
    // si esa talla no existe en el color nuevo.
    b.addEventListener('click', function () { QS.color = c; qsSync(); });
    sw.appendChild(b);
  });
  document.getElementById('qsColorGroup').hidden = colors.length === 0;

  var sz = document.getElementById('qsSizes');
  sz.innerHTML = '';
  sizes.forEach(function (s) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'qs-size';
    b.setAttribute('data-size', s);
    b.textContent = s;
    b.addEventListener('click', function () { if (!b.disabled) { QS.size = s; qsSync(); } });
    sz.appendChild(b);
  });
  document.getElementById('qsSizeGroup').hidden = sizes.length === 0;

  qsSync();
}

function qsSync() {
  var p = QS.prod;

  document.querySelectorAll('#qsSwatches .qs-swatch').forEach(function (b) {
    var on = b.getAttribute('data-color') === QS.color;
    b.classList.toggle('active', on);
    b.setAttribute('aria-pressed', on ? 'true' : 'false');
  });
  var cname = document.getElementById('qsColorName');
  if (cname) cname.textContent = QS.color || '';

  // Tallas realmente comprables en el color elegido
  var avail = [];
  var btns = Array.prototype.slice.call(document.querySelectorAll('#qsSizes .qs-size'));
  btns.forEach(function (b) {
    var s = b.getAttribute('data-size');
    var ok = p.variants.some(function (v) {
      return (QS.colorIdx === -1 || v.options[QS.colorIdx] === QS.color)
          && v.options[QS.sizeIdx] === s && v.available;
    });
    b.disabled = !ok;
    b.classList.toggle('qs-size--out', !ok);
    b.setAttribute('aria-pressed', 'false');
    if (ok) avail.push(s);
  });
  if (QS.size !== null && avail.indexOf(QS.size) === -1) QS.size = null;
  if (QS.size === null && avail.length === 1) QS.size = avail[0];
  btns.forEach(function (b) {
    var on = b.getAttribute('data-size') === QS.size;
    b.classList.toggle('active', on);
    b.setAttribute('aria-pressed', on ? 'true' : 'false');
  });

  var variant = qsVariant();

  var src = (variant && variant.featured_image && variant.featured_image.src)
         || (QS.colorIdx !== -1 ? qsColorImage(QS.color) : p.featured_image);
  var photo = document.getElementById('qsPhoto');
  photo.innerHTML = src
    ? '<img src="' + qsEscapeAttr(qsThumb(src, 400)) + '" alt="' + qsEscapeAttr(p.title + (QS.color ? ' color ' + QS.color : '')) + '">'
    : '<div class="stripe-bg"></div>';

  var prices = p.variants.filter(function (v) {
    return QS.colorIdx === -1 || v.options[QS.colorIdx] === QS.color;
  }).map(function (v) { return v.price; });
  document.getElementById('qsPrice').textContent =
    qsMoney(variant ? variant.price : (prices.length ? Math.min.apply(null, prices) : p.price));

  var link = document.getElementById('qsTitle');
  link.href = '/products/' + p.handle + (variant ? '?variant=' + variant.id : '');

  var note = document.getElementById('qsNote');
  if (avail.length === 0 && QS.sizeIdx !== -1) {
    note.textContent = 'Agotado en este color';
  } else if (QS.preorder) {
    note.textContent = 'Pre-venta · entrega en 7 días hábiles';
  } else {
    note.textContent = '';
  }

  var add = document.getElementById('qsAdd');
  if (!variant) {
    add.disabled = true;
    add.textContent = (avail.length === 0 && QS.sizeIdx !== -1) ? 'Agotado' : 'Elige tu talla';
  } else {
    add.disabled = false;
    add.textContent = QS.preorder ? 'Reservar (pre-venta)' : 'Agregar al carrito';
  }
}

function qaddSubmit(btn) {
  var variant = qsVariant();
  if (!variant) return;
  var prev = btn.textContent;
  btn.disabled = true;
  btn.textContent = '...';
  addToCart(variant.id, 1, function () {
    btn.disabled = false;
    btn.textContent = prev;
    qaddClose();
  });
}

function qsToggleGuide() {
  var panel = document.getElementById('qsGuide');
  var btn = document.getElementById('qsGuideBtn');
  if (!panel || !btn) return;
  var open = panel.hasAttribute('hidden');
  if (open) { panel.removeAttribute('hidden'); } else { panel.setAttribute('hidden', ''); }
  btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  btn.classList.toggle('is-open', open);
  btn.textContent = open ? 'Ocultar guía' : 'Guía de tallas';
  if (open) setTimeout(function () { panel.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); }, 40);
}

function qsEscKey(e) { if (e.key === 'Escape' || e.key === 'Esc') qaddClose(); }

function qsShow() {
  document.getElementById('qsOverlay').classList.add('open');
  document.getElementById('qsSheet').classList.add('open');
  document.body.classList.add('qs-lock');
  document.addEventListener('keydown', qsEscKey);
}

function qaddClose() {
  var g = document.getElementById('qsGuide');
  if (g && !g.hasAttribute('hidden')) qsToggleGuide();
  var sheet = document.getElementById('qsSheet');
  if (sheet) sheet.classList.remove('open');
  var ov = document.getElementById('qsOverlay');
  if (ov) ov.classList.remove('open');
  document.body.classList.remove('qs-lock');
  document.removeEventListener('keydown', qsEscKey);
  if (QS.opener) { try { QS.opener.focus(); } catch (e) {} QS.opener = null; }
}

// ── MOBILE MENU ──────────────────────────────────────────
// Calcula el alto real del encabezado visible (barra de anuncios + nav + barra de
// categorías) y separa el menú justo por debajo, para que la primera categoría
// nunca quede tapada — sin importar el dispositivo ni la posición de scroll.
function kovaMenuOffset() {
  const menu = document.getElementById('mobile-menu');
  if (!menu) return;
  const nav = document.querySelector('nav');
  let bottom = 0;
  if (nav) {
    const r = nav.getBoundingClientRect();
    bottom = Math.max(0, r.bottom);
  }
  if (!bottom) bottom = 93;
  menu.style.paddingTop = Math.round(bottom + 10) + 'px';
}
window.addEventListener('resize', kovaMenuOffset);
window.addEventListener('orientationchange', kovaMenuOffset);

function toggleMobileMenu() {
  const menu = document.getElementById('mobile-menu');
  const burger = document.getElementById('hamburger');
  kovaMenuOffset();
  const isOpen = menu.classList.toggle('open');
  burger.classList.toggle('open', isOpen);
  burger.setAttribute('aria-expanded', isOpen);
  menu.setAttribute('aria-hidden', !isOpen);
  document.body.style.overflow = isOpen ? 'hidden' : '';
}
function closeMobileMenu() {
  const menu = document.getElementById('mobile-menu');
  const burger = document.getElementById('hamburger');
  menu.classList.remove('open');
  burger.classList.remove('open');
  burger.setAttribute('aria-expanded', 'false');
  menu.setAttribute('aria-hidden', 'true');
  document.body.style.overflow = '';
}

// ── CART ─────────────────────────────────────────────────
function toggleCart() {
  const overlay = document.getElementById('cart-overlay');
  const drawer  = document.getElementById('cart-drawer');
  if (!overlay || !drawer) return;
  const isOpen = overlay.classList.toggle('open');
  drawer.classList.toggle('open', isOpen);
  document.body.style.overflow = isOpen ? 'hidden' : '';
}
function openCart() {
  var co = document.getElementById('cart-overlay'); if (co) co.classList.add('open');
  var cd = document.getElementById('cart-drawer'); if (cd) cd.classList.add('open');
  document.body.style.overflow = 'hidden';
}
function closeCart() {
  var co = document.getElementById('cart-overlay'); if (co) co.classList.remove('open');
  var cd = document.getElementById('cart-drawer'); if (cd) cd.classList.remove('open');
  document.body.style.overflow = '';
}

// Add to cart via AJAX
// 2nd arg can be a qty number or a button element (for visual feedback)
function addToCart(variantId, qtyOrBtn, callback) {
  const qty = typeof qtyOrBtn === 'number' ? qtyOrBtn : 1;
  const btn = qtyOrBtn instanceof Element ? qtyOrBtn : null;
  if (btn) btn.textContent = '...';
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ id: parseInt(variantId, 10), quantity: qty })
  })
  .then(r => r.json())
  .then(() => {
    refreshCartDrawer();
    openCart();
    if (btn) btn.textContent = '+ Agregar';
    if (callback) callback();
  })
  .catch(err => {
    console.error('addToCart error:', err);
    if (btn) btn.textContent = '+ Agregar';
    if (callback) callback();
  });
}

// Remove item
function removeFromCart(key) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: 0 })
  })
  .then(r => r.json())
  .then(cart => { updateCartCounts(cart.item_count); renderCartItems(cart); })
  .catch(() => {});
}


function changeQty(key, newQty) {
  if (newQty <= 0) { removeFromCart(key); return; }
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: newQty })
  })
  .then(r => r.json())
  .then(function(c) { updateCartCounts(c.item_count); renderCartItems(c); })
  .catch(function(){});
}

// Refresh cart drawer from /cart.js (works with snippet cart-drawer)
function refreshCartDrawer() {
  fetch('/cart.js')
    .then(r => r.json())
    .then(cart => { updateCartCounts(cart.item_count); renderCartItems(cart); })
    .catch(() => {});
}

function renderCartItems(cart) {
  var itemsEl = document.getElementById('drawer-items');
  var footEl  = document.getElementById('drawer-foot');
  var totalEl = document.getElementById('cart-total');
  if (!itemsEl) return;

  var tierN   = kovaTierCount(cart);
  var hasGift = kovaHasGift(cart);

  if (cart.item_count === 0) {
    itemsEl.innerHTML = '<div class="drawer-empty"><p class="drawer-empty-txt">Tu carrito está vacío.</p></div>';
    if (footEl) footEl.style.display = 'none';
    var recsEl0 = document.getElementById('drawer-recs'); if (recsEl0) recsEl0.style.display = 'none';
    kovaUpdateTier(0, false);
    return;
  }

  // Si el carrito bajo de 5 prendas, el regalo se retira y esto re-renderiza.
  if (kovaGiftEnforce(cart, tierN)) return;

  // Sort: gift items first, then group same product_id together, then by variant_id
  var sorted = cart.items.slice().sort(function(a, b) {
    var ag = a.product_id === __kovaGiftProductId ? 0 : 1;
    var bg = b.product_id === __kovaGiftProductId ? 0 : 1;
    if (ag !== bg) return ag - bg;
    if (a.product_id !== b.product_id) return a.product_id > b.product_id ? 1 : -1;
    return a.variant_id - b.variant_id;
  });

  itemsEl.innerHTML = sorted.map(function(item) {
    var isGift = item.product_id === __kovaGiftProductId;

    var imgHtml;
    if (item.featured_image && item.featured_image.url) {
      imgHtml = '<img src="' + item.featured_image.url + '" alt="' + _esc(item.title) + '" />';
    } else {
      imgHtml = '<div class="stripe-bg"></div>';
    }

    var variantHtml = (!isGift && item.variant_title && item.variant_title !== 'Default Title')
      ? '<p class="ci-variant">' + _esc(item.variant_title) + '</p>'
      : '';

    var priceHtml = '<p class="ci-price">' + _money(item.final_price) + '</p>';

    var qtyCtrl = isGift
      ? '<div class="ci-qty-ctrl"><span class="ci-qty-num">1</span></div>'
      : '<div class="ci-qty-ctrl">' +
          '<button class="ci-qty-btn" onclick="changeQty(\'' + item.key + '\', ' + (item.quantity - 1) + ')">−</button>' +
          '<span class="ci-qty-num">' + item.quantity + '</span>' +
          '<button class="ci-qty-btn" onclick="changeQty(\'' + item.key + '\', ' + (item.quantity + 1) + ')">+</button>' +
        '</div>';

    var nameHtml = _esc(item.product_title);

    // Enlace a la ficha del producto (item.url ya incluye ?variant=)
    var itemUrl = item.url || (item.handle ? '/products/' + item.handle : null);
    var imgBlock = itemUrl
      ? '<a class="ci-img ci-link" href="' + itemUrl + '" aria-label="Ver ' + _esc(item.product_title) + '">' + imgHtml + '</a>'
      : '<div class="ci-img">' + imgHtml + '</div>';
    var nameBlock = itemUrl
      ? '<a class="ci-name-link" href="' + itemUrl + '"><p class="ci-name">' + nameHtml + '</p></a>'
      : '<p class="ci-name">' + nameHtml + '</p>';

    return '<div class="cart-item">' +
      imgBlock +
      '<div class="ci-info">' +
        nameBlock +
        variantHtml +
        priceHtml +
        qtyCtrl +
      '</div>' +
      '<button class="ci-rm" onclick="removeFromCart(\'' + item.key + '\')" aria-label="Eliminar">×</button>' +
    '</div>';
  }).join('') +
    '<div class="drawer-recs" id="drawer-recs" style="display:none;">' +
      '<p class="drawer-recs-title">También te puede gustar</p>' +
      '<div id="drawer-recs-list"></div>' +
    '</div>';
  if (footEl) footEl.style.display = '';
  if (totalEl) totalEl.textContent = _money(cart.total_price);
  kovaUpdateTier(tierN, hasGift);
  renderRecommendations(cart);
}

function _esc(s) {
  return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
}
function _money(cents) {
  return new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(cents / 100);
}

function updateCartCounts(count) {
  document.querySelectorAll('#cart-badge, #mobile-cart-badge').forEach(el => {
    if (el) el.textContent = count;
  });
  const countEl = document.getElementById('cart-count');
  if (countEl) countEl.textContent = count;
}


function kovaGiftOpen() {
  var overlay = document.getElementById('kova-gift-overlay');
  if (!overlay) return;
  var sizesEl = document.getElementById('kova-gift-sizes');
  if (sizesEl) {
    sizesEl.innerHTML = Object.keys(__kovaGiftVariants).map(function(size) {
      return '<button class="kova-modal-size" onclick="kovaGiftAdd(' + __kovaGiftVariants[size] + ')">' + size + '</button>';
    }).join('');
  }
  overlay.style.display = 'flex';
}
function kovaGiftClose() {
  var el = document.getElementById('kova-gift-overlay');
  if (el) el.style.display = 'none';
}
function kovaGiftAdd(variantId) {
  kovaGiftClose();
  var btns = document.querySelectorAll('.kova-gift-btn');
  btns.forEach(function(b) { b.textContent = '...'; b.disabled = true; });
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: 1, properties: { '_gift': 'true' } })
  })
  .then(r => r.json())
  .then(function() { refreshCartDrawer(); })
  .catch(function() {
    btns.forEach(function(b) { b.textContent = '+ AÑADIR REGALO'; b.disabled = false; });
    kovaGiftNotice('No pudimos agregar el regalo. Intenta de nuevo.');
  });
}

function renderRecommendations(cart) {
  var recsEl = document.getElementById('drawer-recs');
  var listEl = document.getElementById('drawer-recs-list');
  if (!recsEl || !listEl) return;
  // Mezcla: prioriza temporada nueva (hasta 2) y completa con los mas vendidos
  var _best = (window.__kovaRecProducts && window.__kovaRecProducts.length) ? window.__kovaRecProducts : (window.__kovaAllProducts || []);
  var _new  = window.__kovaNewProducts || [];
  var _seen = {}, allProds = [];
  _new.slice(0, 2).forEach(function(p){ if(!_seen[p.id]){ _seen[p.id]=1; allProds.push(p); } });
  _best.forEach(function(p){ if(!_seen[p.id]){ _seen[p.id]=1; allProds.push(p); } });
  _new.forEach(function(p){ if(!_seen[p.id]){ _seen[p.id]=1; allProds.push(p); } });
  var cartPids = {};
  cart.items.forEach(function(item) { cartPids[item.product_id] = true; });
  var recs = allProds.filter(function(p) {
    return !cartPids[p.id] && p.id !== __kovaGiftProductId;
  }).slice(0, 3);
  if (recs.length === 0) { recsEl.style.display = 'none'; return; }
  recsEl.style.display = '';
  listEl.innerHTML = recs.map(function(p) {
    var firstVar = p.variants && p.variants[0];
    var priceNum = firstVar ? parseFloat(firstVar.price) : 0;
    var priceStr = '$' + priceNum.toFixed(0) + ' MXN';
    var imgUrl = p.images && p.images[0] ? p.images[0].src : '';
    var recUrl = p.handle ? '/products/' + p.handle : null;
    var imgTag = imgUrl
      ? '<img class="drawer-rec-img" src="' + imgUrl + '" alt="' + _esc(p.title) + '" />'
      : '<div class="drawer-rec-img"></div>';
    var imgHtml = recUrl
      ? '<a class="drawer-rec-link" href="' + recUrl + '" aria-label="Ver ' + _esc(p.title) + '">' + imgTag + '</a>'
      : imgTag;
    var pKey = 'rec-' + p.id;
    var vars = p.variants || [];
    // Nombres de opciones tal como los define el producto (Talla / Color)
    var optNames = (p.options || []).map(function(o){ return (o && o.name) ? o.name : o; });
    var hasColor = optNames.length > 1;
    // Valores únicos por opción, conservando el orden del producto
    function uniq(idx) {
      var seen = {}, out = [];
      vars.forEach(function(v) {
        var val = idx === 0 ? v.option1 : v.option2;
        if (val != null && !seen[val]) { seen[val] = 1; out.push(val); }
      });
      return out;
    }
    var tallas = uniq(0);
    var colores = hasColor ? uniq(1) : [];
    var selTalla = '<select class="drawer-rec-select" data-group="' + pKey + '" data-role="talla" onchange="recSync(this)">' +
      '<option value="">Talla</option>' +
      tallas.map(function(t){ return '<option value="' + _esc(t) + '">Talla ' + _esc(t) + '</option>'; }).join('') +
      '</select>';
    var selColor = hasColor
      ? '<select class="drawer-rec-select" data-group="' + pKey + '" data-role="color" onchange="recSync(this)">' +
        '<option value="">Color</option>' +
        colores.map(function(c){ return '<option value="' + _esc(c) + '">' + _esc(c) + '</option>'; }).join('') +
        '</select>'
      : '';
    return '<div class="drawer-rec-item" data-group="' + pKey + '" data-variants=\'' +
      JSON.stringify(vars.map(function(v){ return {id:v.id, o1:v.option1, o2:v.option2}; })).replace(/'/g, '&#39;') + '\'>' +
      imgHtml +
      '<div class="drawer-rec-info">' +
        (recUrl
          ? '<a class="drawer-rec-name-link" href="' + recUrl + '"><p class="drawer-rec-name">' + _esc(p.title) + '</p></a>'
          : '<p class="drawer-rec-name">' + _esc(p.title) + '</p>') +
        '<p class="drawer-rec-price">' + priceStr + '</p>' +
        '<div class="drawer-rec-selects">' + selTalla + selColor + '</div>' +
        '<button class="drawer-rec-add" disabled onclick="recAdd(this)">AÑADIR</button>' +
      '</div>' +
    '</div>';
  }).join('');
}
function recSync(sel) {
  var item = sel.closest('.drawer-rec-item');
  if (!item) return;
  var vars = [];
  try { vars = JSON.parse(item.getAttribute('data-variants')); } catch (e) { return; }
  var tSel = item.querySelector('.drawer-rec-select[data-role="talla"]');
  var cSel = item.querySelector('.drawer-rec-select[data-role="color"]');
  var addBtn = item.querySelector('.drawer-rec-add');
  if (!addBtn) return;
  var t = tSel ? tSel.value : '';
  var c = cSel ? cSel.value : '';
  var needColor = !!cSel;
  if (!t || (needColor && !c)) { addBtn.disabled = true; addBtn.removeAttribute('data-vid'); return; }
  var match = vars.find(function(v) { return String(v.o1) === String(t) && (!needColor || String(v.o2) === String(c)); });
  if (match) { addBtn.disabled = false; addBtn.dataset.vid = match.id; }
  else { addBtn.disabled = true; addBtn.removeAttribute('data-vid'); }
}
function recAdd(btn) {
  var vid = btn.dataset.vid;
  if (!vid || btn.disabled) return;
  btn.disabled = true; btn.textContent = '...';
  addToCart(parseInt(vid, 10), 1, function() { btn.textContent = '✓'; });
}

// ── PRODUCT FILTER ────────────────────────────────────────
function filterProd(btn, cat) {
  document.querySelectorAll('.pill').forEach(b => b.classList.remove('active'));
  if (btn) btn.classList.add('active');
  document.querySelectorAll('.pcard').forEach(c => {
    const cats = c.dataset.cat || '';
    c.style.display = (cat === 'all' || cats.includes(cat)) ? '' : 'none';
  });
}
function filterCat(e, cat) {
  if (e && e.preventDefault) e.preventDefault();
  document.querySelectorAll('.nav-cats a').forEach(a => a.classList.remove('active'));
  if (e && e.currentTarget) e.currentTarget.classList.add('active');
  filterProd(null, cat);
  const top = document.getElementById('productos');
  if (top) window.scrollTo({ top: top.offsetTop - 60, behavior: 'smooth' });
  closeMobileMenu();
  return false;
}

// ── NEWSLETTER ───────────────────────────────────────────
function nlSub() {
  const el = document.getElementById('nl-email');
  if (el && el.value && el.value.includes('@')) {
    el.value = '';
    el.placeholder = '¡Gracias! Te avisamos en el próximo drop.';
  }
}

// ── ACCORDION ────────────────────────────────────────────
document.addEventListener('click', function(e) {
  const summary = e.target.closest('.accordion-trigger');
  if (!summary) return;
  const icon = summary.querySelector('.accordion-icon');
  const details = summary.closest('details');
  if (icon) icon.textContent = details.open ? '+' : '−';
});

// ── INIT ─────────────────────────────────────────────────
document.addEventListener('DOMContentLoaded', function() {
  // Close cart on overlay click
  var coEl = document.getElementById('cart-overlay'); if (coEl) coEl.addEventListener('click', closeCart);

  // Cargar precios de catálogo + carrito en paralelo
  window.__kovaAllProducts = [];
  window.__kovaRecProducts = [];
  window.__kovaNewProducts = [];
  Promise.all([
    fetch('/products.json?limit=250').then(r => r.json()).catch(function() { return {products:[]}; }),
    fetch('/cart.js').then(r => r.json()).catch(function() { return {item_count:0,items:[]}; }),
    // Recomendaciones del carrito = coleccion 'mas-vendidos' (orden por ventas reales), desacoplada de ROPA/home
    fetch('/collections/mas-vendidos/products.json?limit=250').then(r => r.json()).catch(function() { return {products:[]}; }),
    // Temporada nueva (Drop 002) para priorizar en las recomendaciones del carrito
    fetch('/collections/drop-002/products.json?limit=250').then(r => r.json()).catch(function() { return {products:[]}; })
  ]).then(function(results) {
    var prodData = results[0];
    var cart     = results[1];
    var recData  = results[2];
    var newData  = results[3];
    (prodData.products || []).forEach(function(p) {
      if (p.id !== __kovaGiftProductId) window.__kovaAllProducts.push(p);
    });
    (recData.products || []).forEach(function(p) {
      if (p.id !== __kovaGiftProductId) window.__kovaRecProducts.push(p);
    });
    (newData.products || []).forEach(function(p) {
      if (p.id !== __kovaGiftProductId) window.__kovaNewProducts.push(p);
    });
    updateCartCounts(cart.item_count);
    renderCartItems(cart);
  });

    // Hide mobile sticky bar on desktop
  function handleStickyBar() {
    const bar = document.getElementById('mobile-sticky-bar');
    if (!bar) return;
    bar.style.display = window.innerWidth < 768 ? 'flex' : 'none';
  }
  handleStickyBar();
  window.addEventListener('resize', handleStickyBar);

  // Carousel scroll → sync dots + thumbs
  const prodCarousel = document.getElementById('product-carousel');
  if (prodCarousel) {
    let scrollTimer;
    prodCarousel.addEventListener('scroll', function() {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(() => {
        const idx = Math.round(prodCarousel.scrollLeft / prodCarousel.offsetWidth);
        updateGalleryActiveState(idx);
      }, 60);
    }, { passive: true });
  }

  // Smooth scroll for anchor links
  document.querySelectorAll('a[href^="#"]').forEach(a => {
    a.addEventListener('click', function(e) {
      const target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  // Product page form — AJAX submit (opens cart drawer instead of redirecting)
  const prodForm = document.getElementById('product-form');
  if (prodForm) {
    prodForm.addEventListener('submit', function(e) {
      e.preventDefault();
      var vidEl = document.getElementById('variant-id');
      var variantId = vidEl ? vidEl.value : null;
      var qtyEl = document.getElementById('qty-input');
      var qty = parseInt(qtyEl ? (qtyEl.value || '1') : '1', 10);
      const btn = document.getElementById('atc-btn');
      if (!variantId) return;
      if (btn) { btn.disabled = true; btn.textContent = 'Agregando...'; }
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantId, 10), quantity: qty })
      })
      .then(r => r.json())
      .then(() => {
        refreshCartDrawer();
        openCart();
        if (btn) { btn.disabled = false; btn.textContent = 'Agregar al carrito'; }
      })
      .catch(() => {
        if (btn) { btn.disabled = false; btn.textContent = 'Agregar al carrito'; }
      });
    });
  }
});



/* Superficies de compra que NO se deben tapar con un popup: el panel de
   tallas, la guia, la compra rapida del "+" y el carrito. Un popup encima de
   cualquiera de ellas interrumpe una compra ya empezada. */
window.kovaUiBusy = function () {
  var porEstilo = ['size-calc-modal', 'size-guide-modal'];
  for (var i = 0; i < porEstilo.length; i++) {
    var el = document.getElementById(porEstilo[i]);
    if (el && el.style.display && el.style.display !== 'none') return true;
  }
  var porClase = [['qsSheet', 'open'], ['cart-drawer', 'open'], ['pzoom', 'open']];
  for (var j = 0; j < porClase.length; j++) {
    var e2 = document.getElementById(porClase[j][0]);
    if (e2 && e2.classList.contains(porClase[j][1])) return true;
  }
  return false;
};

/* ── LEAD POPUP ── */
document.addEventListener('DOMContentLoaded', function () {
(function () {
  var POPUP_KEY = 'kova_lead_seen';
  var SESSION_KEY = 'kova_lead_dismissed';
  if (localStorage.getItem(POPUP_KEY)) return;
  if (sessionStorage.getItem(SESSION_KEY)) return;

  var overlay = document.getElementById('lpOverlay');
  if (!overlay) return;

  var delay = parseInt(overlay.getAttribute('data-delay') || '3', 10) * 1000;
  var endpoint = overlay.getAttribute('data-endpoint') || '';

  function dismiss() {
    overlay.hidden = true;
    sessionStorage.setItem(SESSION_KEY, '1');
  }

  var leadData = null;

  function lpSend(payload) {
    if (!endpoint) return;
    fetch(endpoint, {
      method: 'POST',
      mode: 'no-cors',
      headers: { 'Content-Type': 'text/plain' },
      body: JSON.stringify(payload)
    }).catch(function () {});
  }

  function showSuccess() {
    document.getElementById('lpViewForm').hidden = true;
    document.getElementById('lpViewSuccess').hidden = false;
    localStorage.setItem(POPUP_KEY, '1');
    // Nadie nació mañana: el calendario no deja elegir fechas futuras
    var hoy = new Date().toISOString().slice(0, 10);
    ['lpBdayPet', 'lpBdayOwner'].forEach(function (id) {
      var el = document.getElementById(id);
      if (el) { el.max = hoy; el.min = '1900-01-01'; }
    });
  }

  var lpIntentos = 0;
  function lpMostrar() {
    if (window.kovaUiBusy()) {
      if (lpIntentos++ < 40) setTimeout(lpMostrar, 1500);  // reintenta ~1 min
      return;                                             // si sigue ocupado, hoy no toca
    }
    overlay.hidden = false;
  }
  setTimeout(lpMostrar, delay);

  document.getElementById('lpClose').addEventListener('click', dismiss);
  document.getElementById('lpSkip').addEventListener('click', dismiss);
  overlay.addEventListener('click', function (e) { if (e.target === overlay) dismiss(); });

  document.getElementById('lpForm').addEventListener('submit', function (e) {
    e.preventDefault();
    var form = e.target;
    var inputs = form.querySelectorAll('.lp-input');
    var valid = true;
    inputs.forEach(function (inp) {
      inp.classList.remove('lp-input--error');
      if (!inp.value.trim()) { inp.classList.add('lp-input--error'); valid = false; }
    });
    if (!valid) return;

    var payload = {
      nombre: form.nombre.value.trim(),
      mascota: form.mascota.value.trim(),
      correo: form.correo.value.trim(),
      whatsapp: form.whatsapp.value.trim(),
      cumple_mascota: '',
      cumple_cliente: '',
      tipo: 'registro',
      fecha: new Date().toISOString(),
      pagina: window.location.pathname
    };

    leadData = payload;
    lpSend(payload);
    showSuccess();
  });

  // Paso 2: cumpleaños (opcional, ya con el código entregado)
  var bdayForm = document.getElementById('lpBdayForm');
  if (bdayForm) {
    bdayForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var pet = document.getElementById('lpBdayPet').value;
      var own = document.getElementById('lpBdayOwner').value;
      if (pet || own) {
        var payload = {};
        if (leadData) { for (var k in leadData) { payload[k] = leadData[k]; } }
        payload.cumple_mascota = pet;
        payload.cumple_cliente = own;
        payload.tipo = 'cumpleanos';
        payload.fecha = new Date().toISOString();
        lpSend(payload);
      }
      document.getElementById('lpBday').hidden = true;
      document.getElementById('lpBdayDone').hidden = false;
    });
  }

  var copyBtn = document.getElementById('lpCopy');
  if (copyBtn) {
    copyBtn.addEventListener('click', function () {
      var code = 'KOVA10';
      function fallback() {
        var el = document.createElement('textarea');
        el.value = code;
        el.style.cssText = 'position:fixed;opacity:0;';
        document.body.appendChild(el);
        el.select();
        try { document.execCommand('copy'); } catch(ex) {}
        document.body.removeChild(el);
        copyBtn.textContent = '¡Copiado!';
        copyBtn.classList.add('copied');
      }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(function () {
          copyBtn.textContent = '¡Copiado!';
          copyBtn.classList.add('copied');
        }).catch(fallback);
      } else { fallback(); }
    });
  }
}());
});


/* ── ABANDONED CART RECOVERY ── */
document.addEventListener('DOMContentLoaded', function () {
  var CART_SESSION_KEY = 'kova_cart_nudged';
  if (sessionStorage.getItem(CART_SESSION_KEY)) return;
  sessionStorage.setItem(CART_SESSION_KEY, '1');

  fetch('/cart.js')
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      if (cart.item_count > 0) {
        setTimeout(function () {
          refreshCartDrawer();
          openCart();
        }, 2000);
      }
    })
    .catch(function() {});
});


/* ── Landing de cumpleaños (/pages/cumpleanos) ── */
(function () {
  var form = document.getElementById('bdayPageForm');
  if (!form) return;

  var emailEl = document.getElementById('bdayEmail');
  var errEl   = document.getElementById('bdayError');

  // El correo llega por ?e= desde el link del correo. Se rellena en JS, no en
  // Liquid: la pagina va en cache de borde y un valor renderizado se le
  // serviria al siguiente visitante.
  try {
    var params = new URLSearchParams(window.location.search);
    var pre = params.get('e') || params.get('email') || '';
    if (pre && emailEl) emailEl.value = pre.trim();
  } catch (ex) {}

  var hoy = new Date().toISOString().slice(0, 10);
  ['bdayPet', 'bdayOwner'].forEach(function (id) {
    var el = document.getElementById(id);
    if (el) { el.max = hoy; el.min = '1900-01-01'; }
  });

  function endpoint() {
    var lp = document.getElementById('lpOverlay');
    if (lp && lp.getAttribute('data-endpoint')) return lp.getAttribute('data-endpoint');
    return form.getAttribute('data-endpoint') || '';
  }

  function fallar(msg, el) {
    errEl.textContent = msg;
    errEl.hidden = false;
    if (el) el.classList.add('bday-input--error');
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    errEl.hidden = true;
    emailEl.classList.remove('bday-input--error');

    var correo = (emailEl.value || '').trim();
    var pet = document.getElementById('bdayPet').value;
    var own = document.getElementById('bdayOwner').value;

    if (!correo || correo.indexOf('@') < 1 || correo.lastIndexOf('.') < correo.indexOf('@')) {
      return fallar('Necesitamos tu correo para saber a quien escribirle.', emailEl);
    }
    if (!pet && !own) {
      return fallar('Pon al menos una de las dos fechas.');
    }

    var url = endpoint();
    if (url) {
      fetch(url, {
        method: 'POST',
        mode: 'no-cors',
        headers: { 'Content-Type': 'text/plain' },
        body: JSON.stringify({
          correo: correo,
          mascota: (document.getElementById('bdayName').value || '').trim(),
          cumple_mascota: pet,
          cumple_cliente: own,
          tipo: 'cumpleanos',
          fecha: new Date().toISOString(),
          pagina: window.location.pathname
        })
      }).catch(function () {});
    }

    document.getElementById('bdayFormWrap').hidden = true;
    document.getElementById('bdayDone').hidden = false;
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });
}());


/* ── POPUP DE CAUSA — KOVA × CORAZÓN CANINO ──
   Nunca aparece mientras el popup de registro siga sin resolverse.

   Las banderas del popup de registro se leen UNA sola vez, aqui, al cargar
   la pagina. Eso produce el comportamiento pedido sin necesidad de banderas
   extra: en la pantalla donde el cliente resuelve el registro estas banderas
   todavia eran falsas cuando corrio este bloque, asi que el de la causa no
   sale ahi. En la siguiente navegacion ya son verdaderas y sale. Dos modales
   nunca coinciden en pantalla.                                             */
document.addEventListener('DOMContentLoaded', function () {
  var CAUSA_KEY = 'kova_causa_seen';

  var overlay = document.getElementById('ccOverlay');
  if (!overlay) return;

  function leer(store, k) { try { return store.getItem(k); } catch (e) { return null; } }
  function marcarVisto() { try { localStorage.setItem(CAUSA_KEY, '1'); } catch (e) {} }

  if (leer(localStorage, CAUSA_KEY)) return;

  var lead = document.getElementById('lpOverlay');
  var leadResuelto = !lead                                  // popup apagado: nada que esperar
    || leer(localStorage, 'kova_lead_seen')                 // lleno el formulario
    || leer(sessionStorage, 'kova_lead_dismissed');         // lo cerro
  if (!leadResuelto) return;

  var delay = parseInt(overlay.getAttribute('data-delay') || '5', 10) * 1000;
  var intentos = 0;

  function onEsc(e) { if (e.key === 'Escape' || e.keyCode === 27) cerrar(); }

  function cerrar() {
    overlay.hidden = true;
    marcarVisto();
    document.removeEventListener('keydown', onEsc);
  }

  function abrir() {
    // El recuperador de carrito abre el drawer solo a los 2s: no encimarse.
    var drawer = document.getElementById('cart-drawer');
    var lp = document.getElementById('lpOverlay');
    var ocupado = (drawer && drawer.classList.contains('open')) || (lp && !lp.hidden)
                  || window.kovaUiBusy();
    if (ocupado) {
      if (intentos >= 5) return;   // el carrito manda: en esta pagina no toca
      intentos++;
      return setTimeout(abrir, 3000);
    }
    overlay.hidden = false;
    document.addEventListener('keydown', onEsc);
  }

  setTimeout(abrir, delay);

  var btnClose = document.getElementById('ccClose');
  var btnSkip = document.getElementById('ccSkip');
  if (btnClose) btnClose.addEventListener('click', cerrar);
  if (btnSkip) btnSkip.addEventListener('click', cerrar);
  overlay.addEventListener('click', function (e) { if (e.target === overlay) cerrar(); });

  // Irse a la pagina de la causa tambien cuenta como visto: ya cumplio.
  var go = document.getElementById('ccGo');
  if (go) go.addEventListener('click', marcarVisto);
});

/* ══════════ CALCULADORA DE TALLAS ══════════
   Tablas de medidas REALES por tipo de prenda. Cada entrada es [largo_cm, ancho_cm].
   - largo = largo de la prenda, espalda del cuello al nacimiento de la cola
   - ancho = ancho de la prenda medida en plano (la mitad del contorno)

   Origen de cada tabla (no mezclar, no promediar):
     sudadera  → assets/guia-sudaderas.jpg   (medida, tallas 1-12)
     chaleco   → assets/guia-chalecos.jpg    (medida, tallas 1-7)
     alpino    → assets/guia-alpino.jpg      (medida, tallas 1-7, Chamarra Café)
     generico  → snippets/size-table.liquid  (SIN ancho medido — aproximada)

   Para agregar una prenda medida: añadir su clave aquí y mapearla en
   sections/main-product.liquid (_size_table). Nada más.
*/
window.KOVA_SIZE_TABLES = {
  sudadera: { medido: true, sizes: {
    '1':[26,18],'2':[30,20],'3':[33,22],'4':[36,24],'5':[39,27],'6':[42,30],
    '7':[47,35],'8':[49,37],'9':[54,39],'10':[59,43],'11':[63,46],'12':[69,50] } },
  chaleco: { medido: true, sizes: {
    '1':[25,13],'2':[28,15],'3':[32,18],'4':[35,21],'5':[39,24],'6':[44,26],'7':[50,28] } },
  alpino: { medido: true, sizes: {
    '1':[30,20],'2':[33,23],'3':[35,25],'4':[37,26],'5':[40,30],'6':[41,31],'7':[44,36] } },
  generico: { medido: false, sizes: {
    '1':[25,null],'2':[27,null],'3':[29,null],'4':[33,null],'5':[35,null],'6':[39,null],
    '7':[44,null],'8':[48,null],'9':[53,null],'10':[56,null],'11':[59,null],'12':[63,null] } }
};

/* Margen (cm) por debajo del cual el perro "cabe apenas" en la talla elegida
   y conviene ofrecerle la siguiente. */
window.KOVA_SIZE_BORDERLINE_CM = 1.5;

/* Recomendador. Puro: no toca el DOM.
     tableKey  clave de KOVA_SIZE_TABLES
     largo     cm de espalda del perro (obligatorio)
     pecho     cm de contorno de pecho (opcional; sólo genera aviso)
     allowed   array de tallas que ese producto realmente vende, p.ej. ['1','2','3']
   Devuelve null si no hay ninguna talla utilizable. */
window.kovaRecommendSize = function (tableKey, largo, pecho, allowed) {
  var t = window.KOVA_SIZE_TABLES[tableKey] || window.KOVA_SIZE_TABLES.generico;
  var keys = Object.keys(t.sizes)
    .filter(function (k) { return allowed.indexOf(k) !== -1; })
    .sort(function (a, b) { return parseFloat(a) - parseFloat(b); });
  if (!keys.length || !(largo > 0)) return null;

  // La prenda debe cubrir la espalda: la talla más chica cuyo largo alcance.
  var pick = null;
  for (var i = 0; i < keys.length; i++) {
    if (t.sizes[keys[i]][0] >= largo) { pick = keys[i]; break; }
  }
  var overMax = false;
  if (pick === null) { pick = keys[keys.length - 1]; overMax = true; }

  var idx    = keys.indexOf(pick);
  var largoT = t.sizes[pick][0];
  var ancho  = t.sizes[pick][1];
  var margen = largoT - largo;

  // El pecho NO cambia la talla: sólo avisa. El ancho es medida en plano y
  // convertirlo a contorno depende del corte y del estiraje de cada tela.
  var pechoTight = false, capacidad = null;
  if (pecho > 0 && ancho) { capacidad = ancho * 2; pechoTight = pecho > capacidad; }

  return {
    size:       pick,
    prev:       idx > 0 ? keys[idx - 1] : null,
    next:       idx + 1 < keys.length ? keys[idx + 1] : null,
    largoTalla: largoT,
    ancho:      ancho,
    margen:     margen,
    borderline: !overMax && margen <= window.KOVA_SIZE_BORDERLINE_CM,
    overMax:    overMax,
    pechoTight: pechoTight,
    capacidad:  capacidad,
    medido:     t.medido
  };
};
